import { cn } from '@/lib/utils'
import type { MetricStatus } from '../../types'

interface StatusOrbProps {
  status: MetricStatus | 'neutral'
  className?: string
}

export function StatusOrb({ status, className }: StatusOrbProps) {
  return (
    <span
      className={cn(
        'flex-shrink-0 rounded-full',
        status === 'success' && 'bg-success shadow-[0_0_8px_hsl(var(--success)/0.6)]',
        status === 'warning' && 'bg-warning',
        status === 'danger' && 'bg-destructive shadow-[0_0_8px_hsl(var(--destructive)/0.6)]',
        status === 'neutral' && 'bg-muted-foreground/40',
        className,
      )}
    />
  )
}
